import { User } from '@domain/models/account-settings/user.model';

export type AnalyticsEventParams = Record<string, string | number | boolean>;

export abstract class AnalyticsGateway {
  /** Sends one page_view for a post-login route; loads the tag on first use. */
  abstract trackPageView(routerUrl: string, pageTitle: string | undefined, member: User | null | undefined): void;
  /** Custom event; inherits brand, user_id and traffic_type. Queued until the first page_view. */
  abstract trackEvent(eventName: string, params?: AnalyticsEventParams): void;
  /** Stops all collection until the next full page load (sign-out / session end). */
  abstract reset(): void;
}
